import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "print-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7 10.25C6.58579 10.25 6.25 10.5858 6.25 11C6.25 11.4142 6.58579 11.75 7 11.75H8C8.41421 11.75 8.75 11.4142 8.75 11C8.75 10.5858 8.41421 10.25 8 10.25H7Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.25 7.25H5C3.48079 7.25 2.25 8.48079 2.25 10V15C2.25 16.5192 3.48079 17.75 5 17.75H6.25V20C6.25 20.9662 7.03379 21.75 8 21.75H16C16.9662 21.75 17.75 20.9662 17.75 20V17.75H19C20.5192 17.75 21.75 16.5192 21.75 15V10C21.75 8.48079 20.5192 7.25 19 7.25H17.75V4C17.75 3.03379 16.9662 2.25 16 2.25H8C7.03379 2.25 6.25 3.03379 6.25 4V7.25ZM7.75 4C7.75 3.86221 7.86221 3.75 8 3.75H16C16.1378 3.75 16.25 3.86221 16.25 4V7.25H7.75V4ZM7.75 20V14.55H16.25V20C16.25 20.1378 16.1378 20.25 16 20.25H8C7.86221 20.25 7.75 20.1378 7.75 20ZM17.75 13.8V16.25H19C19.6908 16.25 20.25 15.6908 20.25 15V10C20.25 9.30921 19.6908 8.75 19 8.75H5C4.30921 8.75 3.75 9.30921 3.75 10V15C3.75 15.6908 4.30921 16.25 5 16.25H6.25V13.8C6.25 13.3858 6.58579 13.05 7 13.05H17C17.4142 13.05 17.75 13.3858 17.75 13.8Z"
    }, null, -1)
  ])))
}
export default { render: render }